import { render, staticRenderFns } from "./CentroVacinacaoComponente.vue?vue&type=template&id=93fc6692&scoped=true"
import script from "./CentroVacinacaoComponente.vue?vue&type=script&lang=js"
export * from "./CentroVacinacaoComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroVacinacaoComponente.vue?vue&type=style&index=0&id=93fc6692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fc6692",
  null
  
)

export default component.exports